import { prepareState } from './utils';
import { ConsentStorage } from '../ConsentStorage';
export var ACTIONS;
(function (ACTIONS) {
    ACTIONS[ACTIONS["ALLOW_ALL"] = 0] = "ALLOW_ALL";
    ACTIONS[ACTIONS["DISALLOW_ALL"] = 1] = "DISALLOW_ALL";
    ACTIONS[ACTIONS["PROVIDER_ON"] = 2] = "PROVIDER_ON";
    ACTIONS[ACTIONS["PROVIDER_OFF"] = 3] = "PROVIDER_OFF";
})(ACTIONS || (ACTIONS = {}));
export const reducer = (state, action) => {
    let updatedStorage;
    switch (action.type) {
        case ACTIONS.ALLOW_ALL:
            updatedStorage = ConsentStorage.allowAll();
            break;
        case ACTIONS.DISALLOW_ALL:
            updatedStorage = ConsentStorage.removeAllowAll();
            break;
        case ACTIONS.PROVIDER_ON:
            if (action.provider) {
                updatedStorage = ConsentStorage.setProvider(action.provider.hostName, action.provider.displayName);
            }
            break;
        case ACTIONS.PROVIDER_OFF:
            if (action.provider) {
                updatedStorage = ConsentStorage.removeProvider(action.provider.hostName);
            }
            break;
        default:
    }
    if (updatedStorage) {
        return prepareState(updatedStorage, state);
    }
    return state;
};
//# sourceMappingURL=reducer.js.map